import { UserMenu as Menu } from "./UserMenu";
import { UserProfile as Profile } from "./UserProfile";

const User = { Menu, Profile };
export default User;
